/**
 * The web client's "version" for the Nyt i Mesterplan feed: the day this bundle was built
 * (Copenhagen, yyyy-MM-dd), stamped by `vite.config.ts` as `__WEB_BUILD_DATE__`. A note
 * published after this day is not shown until the user has loaded a newer bundle.
 *
 * `undefined` in dev, tests and anywhere else that did not run a production build, which the
 * feed treats as "no gate": developers see every note.
 */
export const WEB_BUILD_DATE: string | undefined =
  typeof __WEB_BUILD_DATE__ !== 'undefined' && __WEB_BUILD_DATE__ ? __WEB_BUILD_DATE__ : undefined;
